/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import * as Cesium from "cesium";
import { CesiumLayer } from "../components/CesiumLayerSettings";
import {
  CesiumMeasurementItem,
  Custom3DTileset,
  CustomGeoJsonDataSource,
} from "../types/CesiumMapItems";

export function getCesiumLayers(viewer: Cesium.Viewer): CesiumLayer[] {
  const layers: CesiumLayer[] = [];
  // Primitives are higher priority, check them first
  const { primitives } = viewer.scene;
  for (let i = 0; i < primitives.length; i++) {
    const p = primitives.get(i);
    if (
      p instanceof Cesium.Cesium3DTileset &&
      (p as Custom3DTileset).layer &&
      !layers.find((l) => l.title === (p as Custom3DTileset).layer)
    ) {
      layers.push({
        title: (p as Custom3DTileset).layer,
        visible: p.show,
      });
    }
  }
  // Check all entities
  const entities = viewer.entities.values;
  entities.forEach((e) => {
    const properties = e.properties?.getValue(
      Cesium.JulianDate.now(),
    ) as CesiumMeasurementItem;
    if (
      properties &&
      properties.layer &&
      !layers.find((l) => l.title === properties.layer)
    ) {
      layers.push({
        title: properties.layer,
        visible: e.isShowing,
      });
    }
  });
  // Check all data sources
  const { dataSources } = viewer;
  for (let i = 0; i < dataSources.length; i++) {
    const d = dataSources.get(i);
    if (
      d instanceof Cesium.GeoJsonDataSource &&
      (d as CustomGeoJsonDataSource).layer &&
      !layers.find((l) => l.title === (d as CustomGeoJsonDataSource).layer)
    ) {
      layers.push({
        title: (d as CustomGeoJsonDataSource).layer,
        visible: d.show,
      });
    }
  }
  return layers;
}
